import PropTypes from 'prop-types';
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from 'react-icons/ai';
import { Button } from 'ypf-pas-general-ui-components';
import './ServiceAccordion.scss';

const RightContentServiceAccordion = (props) => {
  const {
    handleAddService,
    hasOneAccordion,
    index,
    needDate,
    probDate,
    handleModalState,
    serviceFormIncomplete,
    removeAccordion,
    dataService,
    disabledAllFields
  } = props;

  return (
    <>
      <div className="righ-content-service-accordion">
        <Button
          colorIcon="primary"
          disabled={probDate === undefined || serviceFormIncomplete || disabledAllFields}
          icon={AiOutlinePlusCircle}
          onClick={() => handleAddService(index, needDate, probDate)}
          sizeIcon="24px"
          type="button"
          variant="light-gray"
          widthButton="40px"
        />

        <Button
          colorIcon="primary"
          disabled={hasOneAccordion || disabledAllFields}
          icon={AiOutlineMinusCircle}
          onClick={() =>
            handleModalState(
              true,
              () => {
                removeAccordion(index);
              },
              dataService
            )
          }
          sizeIcon="24px"
          type="button"
          variant="light-gray"
          widthButton="40px"
        />
      </div>
    </>
  );
};

RightContentServiceAccordion.propTypes = {
  handleAddService: PropTypes.func.isRequired,
  disabledAllFields: PropTypes.bool,
  hasOneAccordion: PropTypes.bool.isRequired,
  serviceFormIncomplete: PropTypes.bool,
  index: PropTypes.number.isRequired,
  needDate: PropTypes.string,
  probDate: PropTypes.string,
  handleModalState: PropTypes.func.isRequired,
  removeAccordion: PropTypes.func.isRequired,
  dataService: PropTypes.shape({
    fecha: PropTypes.string,
    nombre: PropTypes.string
  })
};

RightContentServiceAccordion.defaultProps = {
  needDate: '',
  probDate: '',
  disabledAllFields: false,
  dataService: {
    fecha: '',
    nombre: ''
  },
  serviceFormIncomplete: false
};

export default RightContentServiceAccordion;
